import SiteLayout from '@/components/feature/SiteLayout';
import useSEO from '@/hooks/useSEO';
import { getByType, getNewsByDate, getStoriesByTime, getStoriesByWeight } from '@/lib/content';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import SeriesProfile from '@/pages/home/components/SeriesProfile';
import StoryHighlights from '@/pages/home/components/StoryHighlights';
import NewsHighlights from '@/pages/home/components/NewsHighlights';
import CastSpotlight from '@/pages/home/components/CastSpotlight';
import AboutStrip from '@/pages/home/components/AboutStrip';

export default function Home() {
  useSEO({
    title: '我的朋友他的妻子影视大全—剧情介绍与精彩片段',
    description:
      '我的朋友他的妻子影视站提供该作品的剧情介绍、演员详情和相关新闻。用户可了解最新影视资讯，深度剖析影片内容，丰富观影体验。',
    keywords: '我的朋友他的妻子,影视剧,剧情介绍,演员表,影视资讯,影视评论',
  });

  const heroSlides = getStoriesByWeight().slice(0, 3);
  const news = getNewsByDate();
  const stories = getStoriesByTime();
  const cast = [...getByType('cast')].sort((a, b) => b.weight - a.weight);

  return (
    <SiteLayout noTopPadding>
      <HeroCarousel slides={heroSlides} news={news.slice(0, 4)} />
      <SeriesProfile />
      <StoryHighlights items={stories.slice(0, 3)} />
      <NewsHighlights items={news.slice(0, 5)} />
      <CastSpotlight items={cast.slice(0, 6)} />
      <AboutStrip />
    </SiteLayout>
  );
}